{
  "completed": "Lõpetatud: ",
  "current": "Praegune: ",
  "notCompleted": "Lõpetamata: ",
  "steplist": "Sammude loend"
}
